import { SITE_URL } from "@/lib/site-url";

const OG_IMAGE = `${SITE_URL}/assets/og/og-home.jpg`;

const COPY = {
  es: {
    path: "/",
    locale: "es_ES",
    altLocale: "en_GB",
    title: "Retail Lemon | Club Pro y Agente Retail IA para comercios",
    description:
      "Agente Retail IA, hoja de ruta y herramientas para comercios y hostelería a pie de calle. Básico 39 €, Club Pro 69 € y Avanzado 99 €/mes con 7 días gratis, sin permanencia.",
    imageAlt: "Retail Lemon: Agente Retail IA y Club Pro para comercios a pie de calle",
  },
  en: {
    path: "/en",
    locale: "en_GB",
    altLocale: "es_ES",
    title: "Retail Lemon | Club Pro & Retail AI Agent for local shops",
    description:
      "Retail AI Agent, roadmap and tools for high-street shops and hospitality. Basic €39, Club Pro €69 and Advanced €99/month with a 7-day free trial, no commitment.",
    imageAlt: "Retail Lemon: Retail AI Agent and Club Pro for high-street businesses",
  },
} as const;

export function goHead(lang: "es" | "en") {
  const c = COPY[lang];
  const url = c.path === "/" ? `${SITE_URL}/` : `${SITE_URL}${c.path}`;
  const esUrl = `${SITE_URL}/`;
  const enUrl = `${SITE_URL}/en`;
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${SITE_URL}/#organization`,
        name: "Retail Lemon",
        url: SITE_URL,
        logo: `${SITE_URL}/og-retail-lemon.jpg`,
      },
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        url,
        name: c.title,
        description: c.description,
        inLanguage: lang,
        isPartOf: { "@type": "WebSite", name: "Retail Lemon", url: SITE_URL },
        primaryImageOfPage: OG_IMAGE,
      },
      {
        "@type": "SoftwareApplication",
        name: "Retail Lemon",
        applicationCategory: "BusinessApplication",
        operatingSystem: "Web",
        offers: [
          { "@type": "Offer", name: lang === "es" ? "Básico" : "Basic", price: "39", priceCurrency: "EUR" },
          { "@type": "Offer", name: "Club Pro", price: "69", priceCurrency: "EUR" },
          { "@type": "Offer", name: lang === "es" ? "Avanzado" : "Advanced", price: "99", priceCurrency: "EUR" },
        ],
      },
    ],
  };
  return {
    meta: [
      { title: c.title },
      { name: "description", content: c.description },
      { name: "robots", content: "index, follow, max-image-preview:large" },
      { property: "og:title", content: c.title },
      { property: "og:description", content: c.description },
      { property: "og:url", content: url },
      { property: "og:type", content: "website" },
      { property: "og:site_name", content: "Retail Lemon" },
      { property: "og:locale", content: c.locale },
      { property: "og:locale:alternate", content: c.altLocale },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:secure_url", content: OG_IMAGE },
      { property: "og:image:type", content: "image/jpeg" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: c.imageAlt },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: c.title },
      { name: "twitter:description", content: c.description },
      { name: "twitter:image", content: OG_IMAGE },
      { name: "twitter:image:alt", content: c.imageAlt },
    ],
    links: [
      { rel: "canonical", href: url },
      { rel: "alternate", hrefLang: "es", href: esUrl },
      { rel: "alternate", hrefLang: "en", href: enUrl },
      { rel: "alternate", hrefLang: "x-default", href: esUrl },
    ],
    scripts: [{ type: "application/ld+json", children: JSON.stringify(jsonLd) }],
  };
}
